import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/unidadesDeNegocios/businessUnits";
import businessUnit from "../../models/unidadDeNegocios/businessUnit";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    businessUnits: [],
    open: false,
    mode: "",
    new: {},
    edit: {},
    editRelation: {},
    itemDelete: null,
    openDelete: false,
    showCard: false,
    showTable: false,
    openFormRelation: false,
    modeFormRelation: "",
    cats: [],
    unitId: null,
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setBusinessUnits(state, data) {
      state.businessUnits = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setShowCard(state, data) {
      state.showCard = data;
    },
    setShowTable(state, data) {
      state.showTable = data;
    },
    setOpenFormRelation(state, data) {
      state.openFormRelation = data;
    },
    setModeFormRelation(state, data) {
      state.modeFormRelation = data;
    },
    setEditRelation(state, data) {
      state.editRelation = data;
    },
    setTablesAccessCode(state, data) {
      state.cats = data;
    },
    setUnitId(state, data) {
      state.unitId = data;
    },
  },
  actions: {
    async getBusinessUnits(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getBusinessUnits();
          state.commit("setBusinessUnits", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getCats(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getCats();
          state.commit("setTablesAccessCode", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getBusinessUnitsId({ state, commit }, id) {
      try {
        const data = await state.service.getBusinessUnitId(id);
        commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async add(state) {
      try {
        const response = await state.state.service.addBusinessUnit(
          state.state.new
        );
        const newItem = businessUnit.fromJson(response.data);
        const updated = [newItem, ...state.state.businessUnits];
        state.commit("setBusinessUnits", updated);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteBusinessUnit(state.state.itemDelete)
            .then(() => {
              let options = state.state.businessUnits;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setBusinessUnits", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editBusinessUnit(state.state.editRelation)
            .then(async () => {
              const data = await state.state.service.getBusinessUnits();
              state.commit("setBusinessUnits", data);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //Operador-Empleado
    async addEmployeeToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addEmployeeToOperator(
            state.state.new
          );
          const newItem = state.state.new;

          if (!state.state.edit.empleados) {
            const updatedEdit = {
              ...state.state.edit,
              empleados: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              empleados: [newItem, ...state.state.edit.empleados],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteEmployeeToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteEmployeeToOperator(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.empleados;

              options = options.filter((option) => {
                return option.empId !== state.state.itemDelete.empId;
              });

              let edit = { ...state.state.edit };
              edit.empleados = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    //Operador-Grupo
    async addGroupToOperator(state) {
      try {
        const response = await state.state.service.addGroupToOperator(
          state.state.new
        );

        const newItem = state.state.new;

        if (!state.state.edit.grupos) {
          const updatedEdit = {
            ...state.state.edit,
            grupos: [newItem],
          };

          state.commit("setEdit", updatedEdit);
        } else {
          const updatedEdit = {
            ...state.state.edit,
            grupos: [newItem, ...state.state.edit.grupos],
          };

          state.commit("setEdit", updatedEdit);
        }

        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteGroupToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteGroupToOperator(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.grupos;

              options = options.filter((option) => {
                return option.grupoId !== state.state.itemDelete.grupoId;
              });

              let edit = { ...state.state.edit };
              edit.grupos = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //Operadores-Unidades de Negocios

    async addBusinessUnitsToOperator(state) {
      try {
        const response = await state.state.service.addOperatorToBusinessUnit(
          state.state.new
        );
        const newItem = response.data;

        const formattedNew = {
          operNombre: state.state.new.operName,
          ...newItem,
        };

        if (!state.state.edit.operadores) {
          const updatedEdit = {
            ...state.state.edit,
            operadores: [newItem],
          };

          state.commit("setEdit", updatedEdit);
        } else {
          const updatedEdit = {
            ...state.state.edit,
            operadores: [...state.state.edit.operadores, formattedNew],
          };

          state.commit("setEdit", updatedEdit);
        }

        return true;
      } catch (error) {
        throw error;
      }
    },
    async editBusinessUnitsToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editOperatorToBusinessUnit(state.state.editRelation)
            .then(async () => {
              const id = state.state.edit.unNegocioId;

              const data = await state.state.service.getBusinessUnitId(id);
              state.commit("setEdit", data);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteBusinessUnitsToOperator(state) {
      try {
        await state.state.service.deleteBusinessUnitToOperator(
          state.state.itemDelete
        );
        const options = state.state.edit.operadores.filter(
          (option) => option.operId !== state.state.itemDelete.operId
        );

        state.commit("setEdit", { ...state.state.edit, operadores: options });

        return true;
      } catch (error) {
        throw error;
      }
    },

    //Tablas-Unidades de Negocios
    async addBusinessUnitsToTable(state) {
      try {
        const response = await state.state.service.addTableToBusinessUnit(
          state.state.new
        );
        const newItem = response.data;

        if (!state.state.edit.tablas) {
          const updatedEdit = {
            ...state.state.edit,
            tablas: [newItem],
          };

          state.commit("setEdit", updatedEdit);
        } else {
          const updatedEdit = {
            ...state.state.edit,
            tablas: [...state.state.edit.tablas, newItem],
          };

          state.commit("setEdit", updatedEdit);
        }

        return true;
      } catch (error) {
        throw error;
      }
    },
    async editBusinessUnitsToTable(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editTableToBusinessUnit(state.state.editRelation)
            .then(async () => {
              const id = state.state.edit.unNegocioId;
              const data = await state.state.service.getBusinessUnitId(id);
              state.commit("setEdit", data);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteBusinessUnitsToTable(state) {
      try {
        await state.state.service.deleteTableToBusinessUnit(
          state.state.itemDelete
        );
        const options = state.state.edit.tablas.filter(
          (option) => option.tabla !== state.state.itemDelete.name
        );

        state.commit("setEdit", { ...state.state.edit, tablas: options });

        return true;
      } catch (error) {
        throw error;
      }
    },
  },
});
